// extracted by mini-css-extract-plugin
export default {"appContainer":"Home_appContainer__IPkFK"};